/*
 * Sidebar collapsed state — single source of truth for both the
 * workspace shell and the platform-admin shell. Persists per user via
 * localStorage so the choice survives reloads.
 */

import { useCallback, useEffect, useState } from "react";

const KEY = "tallystream.sidebar.collapsed";

export function useSidebarCollapsed(): {
  collapsed: boolean;
  toggle: () => void;
  setCollapsed: (next: boolean) => void;
} {
  const [collapsed, setState] = useState<boolean>(() => {
    try { return localStorage.getItem(KEY) === "1"; } catch { return false; }
  });
  useEffect(() => {
    try {
      localStorage.setItem(KEY, collapsed ? "1" : "0");
      // Reflect on <body> so the grid layout can react via CSS without
      // every component plumbing the boolean through.
      document.body.classList.toggle("sidebar-collapsed", collapsed);
    } catch { /* ignore */ }
  }, [collapsed]);
  const setCollapsed = useCallback((next: boolean) => setState(next), []);
  const toggle = useCallback(() => setState((c) => !c), []);
  return { collapsed, toggle, setCollapsed };
}
